import React from 'react'
import Tooltip from 'pobble-components/dist/tooltip'
import injectSheet from 'react-jss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle'

export const ColorsInfo = injectSheet({
  tooltip: {
    maxWidth: '300px'
  },
  container: {
    '& p': {
      display: 'flex',
      margin: '16px 0',
      alignItems: 'center',
      padding: '8px 12px',
      borderRadius: '4px',
      color: 'var(--gray)'
    }
  },
  trigger: {
    color: 'var(--blue)',
    fontWeight: 'bold'
  }
})(({ classes }) => {
  return (
    <Tooltip
      tooltipClassName={classes.tooltip}
      content={
        <div className={classes.container}>
          <p style={{ backgroundColor: '#fff' }}>Teacher from your school</p>
          <p
            style={{
              backgroundColor: 'var(--yellow-)'
            }}>
            Teacher from another school
          </p>
          <p
            style={{
              backgroundColor: 'var(--purple-)',
              color: '#fff'
            }}>
            Doesn't have a Pobble account
          </p>
        </div>
      }>
      <span className={classes.trigger}>
        <FontAwesomeIcon icon={faInfoCircle} /> What do these colours mean?
      </span>
    </Tooltip>
  )
})
